const PERFIL_PATH = '/perfil' as const;

export const ROUTES_PATH = {
  LAWSUIT_MONITOR: {
    BASE: '/jusprocessos',
    BASE_V2: '/jusprocessos-v2',
    SUBSCRIPTION: '/assinatura',
    LAWSUITS: '/meus-processos',
    DETAILS: '/detalhes',
    CASE_MAP: '/mapa',
    DEADLINES: '/prazos',
    COMPLETED_DEADLINES: '/prazos-concluidos',
    CONFIG: '/configuracoes',
    ADICAO_CNJ: '/adicao-cnj',
    DEADLINES_LIST: `/prazos/lista`,
    DEADLINES_CALENDAR: `/prazos/calendario`,
    SETUP_STEPS: '/etapas',
    SETUP: '/inicio',
  },
  JUSZAP: {
    LANDING_PAGE: '/assistente-whatsapp',
    BASE: '/space/whatsapp',
    TEAM_MANAGEMENT: '/space/whatsapp/gerenciamento-equipe',
    MEETINGS: '/space/whatsapp/reunioes',
    CUSTOM_FLOW: '/space/whatsapp/upgrade-personalizado',
  },
  GAMIFICATION: {
    BASE: '/gamificacao',
    HISTORICO: '/gamificacao/historico',
  },
  AFILIADOS: {
    BASE: '/afiliados',
  },
  ONBOARDING: {
    WELCOME: '/onboarding/boas-vindas',
    ADDRESS: '/onboarding/endereco',
    OAB: '/onboarding/oab',
    OFFICE: '/onboarding/perfil',
    PHOTO: '/onboarding/foto',
    TOOLS: '/onboarding/ferramentas',
  },
  MAIN: {
    DASHBOARD: '/dashboard',
    JUSFINDER_QUERY: '/jusfinder/query',
    ASSINATURAS: '/assinaturas',
    GPT: '/gpt',
    GPT_BUSINESS: '/gpt/business',
    JURISPRUDENCIA: '/jurisprudencia',
    MEU_DRIVE: '/meu-drive',
    ESTUDOS: '/estudos',
    CARREIRA: '/carreira',
    ACADEMY: '/academy',
  },
  JUSFYPAY: {
    CHARGES: '/jusfypay/charges',
    NEW_CHARGE: '/jusfypay/new-charge',
    SIMULATOR: '/jusfypay/simulator',
    WALLET: '/jusfypay/wallet',
    PROFILE: '/jusfypay/profile',
    ANTECIPACAO: '/jusfypay/antecipacao',
    ANTECIPACAO_COMO_FUNCIONA: '/jusfypay/antecipacao/como-funciona',
    ANTECIPACAO_MEU_PAINEL: '/jusfypay/antecipacao/meu-painel',
  },
  SETTINGS: {
    PERFIL: PERFIL_PATH,
    SOBRE: '/sobre',
  },
  AUTH: {
    LOGOUT: '/logout',
  },
  PROCESSOS: {
    JUSFINDER_QUERY: '/jusfinder/query',
    HISTORY_BATCH: '/jusfinder/history_batch',
    CALCULADORAS: '/calculadoras',
    PETICOES: '/peticoes',
    MEUS_PROCESSOS: '/jusprocessos/meus-processos',
    PRAZOS: '/jusprocessos/prazos/lista',
    AGENDA: '/agenda',
  },
  CLIENTES: {
    ASSINATURAS: '/assinaturas',
    CLIENTES: '/clientes',
    SPACE_DOMAIN: '/space/domain',
    JUSMAIL_REDIRECT: '/jusmail-redirect',
    OPORTUNIDADES: '/oportunidades',
    /** Listagem de sugestões OAB (triagem de clientes). */
    OAB_SUGESTOES: '/clientes/oab-sugestoes',
    /** Aba de diligências dentro de Oportunidades. */
    DILIGENCIAS: '/oportunidades/diligencias',
    /** Wizard de contratação: tela cheia, fora das abas. */
    CONTRATAR_CORRESPONDENTE: '/diligencias/contratar-correspondente',
    PAGE: '/page',
    CRIADOR_CONTEUDO: '/criador-de-conteudo',
  },
  /**
   * JusScore RH — a carteira de pessoas lida pelo motor de score, perfil `hr`.
   *
   * O caminho é minúsculo aqui, mas o react-router v5 casa sem distinguir caixa:
   * `/juscore-RH` (a forma do protótipo) continua abrindo a mesma tela.
   */
  JUSCORE_RH: {
    BASE: '/juscore-rh',
    DETALHES: '/juscore-rh/detalhes/:pessoaId',
    PASTAS: '/juscore-rh/pastas',
    PASTA: '/juscore-rh/pastas/:pastaId',
  },
  CONFIGURACOES: {
    ACCOUNT_PROFILE: PERFIL_PATH,
    PLAN_AND_PAYMENT: '/plano-e-pagamento',
    SECURITY: '/seguranca',
    USUARIOS: '/usuarios',
    OFFICE: '/escritorio',
  },
  EXTERNAL: {
    COMUNIDADE: 'https://comunidade.jusfy.com.br/top?period=monthly',
    MANUALS: 'https://help.jusfy.com.br',
  },
  CALCULADORAS: {
    CALCULOS: '/calculos',
    ATUALIZACAO: '/atualizacao',
    ATUALIZACAO_COMPLETO: '/atualizacao_completo',
    PRECATORIOS: '/precatorios',
    REVISIONAL: '/revisional',
    SUPERENDIVIDAMENTO: '/superendividamento',
    RMC: '/rmc',
    PASEP: '/pasep',
    TRABALHISTA: '/trabalhista',
    FGTS: '/fgts',
    PENSAO: '/pensao',
    ALUGUEL: '/aluguel',
    DIVORCIO: '/divorcio',
    PREVIDENCIARIA: '/previdenciaria',
    ACIMA_TETO: '/acima-teto',
    INSS: '/inss',
    PROGRESSAO_REGIME: '/progressao-regime',
    DOSIMETRIA_PENA: '/dosimetria-pena',
    FAMILIAR: '/familiar',
    BANCARIO: '/bancario',
    CONSUMIDOR: '/consumidor',
  },
  CONTABILIDADE: {
    LANDING_PAGE: '/contabilidade',
    CONTATO: '/contabilidade/contato',
    DASHBOARD: '/contabilidade/dashboard',
    NOTAS: '/contabilidade/notas',
  },
  JUSCLASS: {
    BASE: '/cursos',
  },
  RELATORIO: {
    EDITAR: '/relatorio/editar',
  },
} as const;

export const CALCULADORAS_PATHS = Object.values(ROUTES_PATH.CALCULADORAS);
export const JUSZAP_PATHS = Object.values(ROUTES_PATH.JUSZAP);

/**
 * O caminho da ficha de uma pessoa no JusScore RH.
 *
 * O id vai codificado porque ele vem da API e não de uma lista fechada: um id
 * inesperado não deveria poder escapar do segmento da URL.
 */
export const caminhoDaPessoaJusScoreRh = (id: number | string): string =>
  `${ROUTES_PATH.JUSCORE_RH.BASE}/detalhes/${encodeURIComponent(String(id))}`;

/** O caminho de uma pasta do JusScore RH. Mesma regra do id acima. */
export const caminhoDaPasta = (id: number | string): string =>
  `${ROUTES_PATH.JUSCORE_RH.PASTAS}/${encodeURIComponent(String(id))}`;
